const ARGENTINA = 'Argentina';
const BOLIVIA = 'Bolivia';
const BRASIL = 'Brasil';
const CHILE = 'Chile';
const COLOMBIA = 'Colombia';
const ECUADOR = 'Ecuador';
const GUYANA = 'Guyana';
const MEXICO = 'México';
const PARAGUAY = 'Paraguay';
const PERU = 'Perú';
const SURINAM = 'Surinam';
const URUGUAY = 'Uruguay';
const VENEZUELA = 'Venezuela';

const COUNTRIES = [
  ARGENTINA,
  BOLIVIA,
  BRASIL,
  CHILE,
  COLOMBIA,
  ECUADOR,
  GUYANA,
  MEXICO,
  PARAGUAY,
  PERU,
  SURINAM,
  URUGUAY,
  VENEZUELA,
];

module.exports = {
  ARGENTINA,
  BOLIVIA,
  BRASIL,
  CHILE,
  COLOMBIA,
  ECUADOR,
  GUYANA,
  MEXICO,
  PARAGUAY,
  PERU,
  SURINAM,
  URUGUAY,
  VENEZUELA,
  COUNTRIES,
};
